<template>
	<ProcessCreatePage>
		<Header :title="title">
			<p>
				{{ $t('enter_sign_location_input') }}
			</p>
		</Header>

		<div class="main">
			<default-or-value-form
				ref="form"
				v-model="signLocation"
				@input="setLocation($event)"
				:show-input-field="false"
				:default-value="defaultCity"
				:placeholder="$t('location_name').toString()"
				:custom-value-error-message="$t('enter_sign_location')"
				:force-custom-value="$store.getters.getAuthenticatedUserGroupLevel === '2'"
			>
				<template #default>
					<label>{{ $t('on_site') }} {{ $store.getters.repairShopLabel }}:<br /></label>
					<span class="font-semibold">{{ defaultCity }}</span>
				</template>
				<template #custom>
					<p>{{ $t('elsewhere') }} {{ $store.getters.repairShopLabel }}es: <br /></p>
				</template>
			</default-or-value-form>
		</div>

		<Footer
			@backButtonClick="$emit('previous', $event)"
			:is-back-button="showBackButton"
			@continueButtonClick="continueButtonClick"
			:is-skippable="false"
		/>
	</ProcessCreatePage>
</template>

<script>
import Header from '../Header';
import Footer from '../Footer';
import DefaultOrValueForm from '@/components/damagecases/forms/DefaultOrValueForm';
import ProcessCreatePage from '@/views/management/Process/ProcessCreatePage';

export default {
	name: 'SignLocation',
	data() {
		return {
			signLocation: '',
			isNotDefaultLocation: false,
		};
	},
	props: {
		defaultCity: {
			type: String,
			required: true,
		},
		showBackButton: {
			default: false,
		},
		title: {
			default: function() {
				return this.$t('generate_form_sign_location');
			},
		},
	},
	methods: {
		setLocation(event) {
			this.isNotDefaultLocation = event.isNotDefaultLocation;
		},
		continueButtonClick() {
			if (this.$refs.form.validate()) {
				const signLocationReq = {};

				if (this.isNotDefaultLocation) {
					this.signLocation = null;
					signLocationReq.isNotDefaultLocation = true;
				} else {
					this.signLocation = this.defaultCity;
					signLocationReq.isNotDefaultLocation = false;
				}
				signLocationReq.signLocation = this.signLocation;

				this.$emit('next', signLocationReq);
			} else {
				this.$swal(this.$t('general.attention').toString(), this.$t('please_check_input').toString(), 'warning');
			}
		},
	},
	components: { ProcessCreatePage, DefaultOrValueForm, Footer, Header },
};
</script>

<style scoped></style>
